import React, { useState, useEffect } from 'react';
import { MethodEnum } from 'axios/type';
import { formatDate, dateStrParse } from 'components/DatePicker/consts';
import DateEnum from 'components/DatePicker/enum';
import Rim from 'components/_form/Rim';
import TableTit from 'components/_form/TableTit';
import { showResponseSnackBar } from 'consts';
import ButtonVariantEnum from 'tradevan-ui/Button/enum';
import { inputVal, classCombine } from 'tradevan-ui/consts';
import {
  EnumDocType,
  EnumRetailerSetup,
  EnumMasterSort,
  EnumFunctionId,
} from 'view/Layout/enum';
import { TableProps } from 'components/Table/type';
import Button from 'tradevan-ui/Button';
import Table from 'components/Table';
import PDFReader, { PDFReaderProps } from 'components/PDFReader';
import {
  IlogRecordQueryRequest,
  IlogRecordQueryResponse,
} from 'view/Layout/Project/RcvQuery/components/ResultSecion/type';
import DownloadPdfButton from 'view/Layout/Project/components/downloadPdfButton';
import CopyButton from 'view/Layout/components/CopyDiv';
import StatusEnum from 'axios/enum';
import Modal from 'tradevan-ui/Modal';
import useAxios from 'axios/useAxios';
import {
  IqueryReportSettingRequest,
  IqueryReportSettingResponse,
} from 'view/Layout/type';
import { getColumns } from './consts';
import { Idetail, EnumDetail, EnumMaster } from '../../init';
import {
  ResultSecionProps,
  OrderDownloadPreviewRequest,
  IorderDownloadPreviewRequest,
} from './type';
import DownloadPdf from './components/DownloadPdf';

const ResultSecion = (props: ResultSecionProps) => {
  const {
    handleSearch,
    formReturnDetail,
    userInfoReducer,
    _retailerSetup: [retailerSetup],
    _showLogRecordModal: [, setShowLogRecordModal],
    _logRecordData: [, setLogRecordData],
  } = props;
  const axios = useAxios();

  // 報表預覽工具
  const [pdfObj, setPdfObj] = useState<PDFReaderProps>({
    show: false,
    file: '',
    onClose: () =>
      setPdfObj((prev: PDFReaderProps) => ({ ...prev, show: false })),
  });

  // 判斷預覽、下載
  const [triggerAction, setTriggerAction] = useState<string | null>(null);

  const { watch, setValue, handleSubmit } = formReturnDetail;
  // 是否開啟詢問視窗
  const [askPriceShowModal, setShowModal] = useState(false);
  // 紀錄Row 的參數
  const [selectedRow, setSelectedRow] = useState<Idetail | null>(null);

  const master = watch('master');
  const detail = watch('detail');
  const pageObj = watch('pageObj');
  const masterSort = watch('masterSort');

  /** 點閱紀錄 資料查詢 */
  const getLogRecord = async (row: Idetail) => {
    const response = await axios.doAxios<
      IlogRecordQueryRequest,
      IlogRecordQueryResponse
    >(MethodEnum.post, 'logRecord/query', {
      retailerId: row[EnumDetail.retailerId],
      actionType: '',
      docType: EnumDocType.訂單,
      docNo: row[EnumDetail.orderNo],
      docSeqNo: row[EnumDetail.orderSeqNo],
    });
    if (response) {
      const { data } = response.data;
      setLogRecordData(data.contents.map((v, i) => ({ ...v, id: String(i) })));
      setShowLogRecordModal(true);
      showResponseSnackBar(response.data);
    }
  };

  // 批次下載PDF
  const download = async (
    inputPreviewShowPrice: boolean,
    inputDownloadShowPrice: boolean,
  ) => {
    // console.log('download, previewShowPrice', inputPreviewShowPrice);
    // console.log('download, downlodShowPrice', inputDownloadShowPrice);
    const response = await axios.blobAxios<IorderDownloadPreviewRequest>(
      MethodEnum.post,
      'order/download',
      {
        [OrderDownloadPreviewRequest.retailerId]: master[EnumMaster.retailerId],
        [OrderDownloadPreviewRequest.userRole]: userInfoReducer.role,
        [OrderDownloadPreviewRequest.orderSeqNos]: detail
          .filter((v) => v.selected && !v.selectHidden) // 有勾選且有看的見
          .map((v) => v[EnumDetail.orderSeqNo]),
        [OrderDownloadPreviewRequest.sort]: masterSort
          .filter((v) => v[EnumMasterSort.property] !== '')
          .map((v) => ({
            ...v,
            [EnumMasterSort.desc]: v.desc ? 'Y' : 'N',
          })),
        [OrderDownloadPreviewRequest.previewShowPrice]:
          inputPreviewShowPrice || false,
        [OrderDownloadPreviewRequest.downloadShowPrice]:
          inputDownloadShowPrice || false,
      },
    );
    axios.blobDownload(response);
    handleSubmit(handleSearch())();
  };

  // 預覽列印(單筆/批次)
  const previewReport = async (
    row?: Idetail,
    inputPreviewShowPrice?: boolean,
    inputDownloadShowPrice?: boolean,
  ) => {
    // console.log('previewReport, previewShowPrice', inputPreviewShowPrice);
    // console.log('previewReport, downlodShowPrice', inputDownloadShowPrice);
    const request = {
      [OrderDownloadPreviewRequest.retailerId]: master[EnumMaster.retailerId],
      [OrderDownloadPreviewRequest.userRole]: userInfoReducer.role,
      // Table 訂單編號，會顯示單筆資料
      [OrderDownloadPreviewRequest.orderSeqNos]: row
        ? [row[EnumDetail.orderSeqNo]]
        : detail
            .filter((v) => v.selected && !v.selectHidden) // 有勾選且有看的見
            .map((v) => v[EnumDetail.orderSeqNo]),
      [OrderDownloadPreviewRequest.sort]: masterSort
        .filter((v) => v[EnumMasterSort.property] !== '')
        .map((v) => ({
          ...v,
          [EnumMasterSort.desc]: v.desc ? 'Y' : 'N',
        })),
      [OrderDownloadPreviewRequest.previewShowPrice]:
        inputPreviewShowPrice || false,
      [OrderDownloadPreviewRequest.downloadShowPrice]:
        inputDownloadShowPrice || false,
    };

    const response = await axios.blobAxios<IorderDownloadPreviewRequest>(
      MethodEnum.post,
      'order/preview',
      request,
    );

    setPdfObj((prev: PDFReaderProps) => ({
      ...prev,
      show: true,
      file: window.URL.createObjectURL(response.data),
      customChild: <DownloadPdfButton pageName="order" request={request} />,
    }));
  };

  function handleReportProcess(
    action: string,
    inputRow: Idetail | null,
    inputPreviewShowPrice: boolean,
    inputDownloadShowPrice: boolean,
  ) {
    // console.log(
    //   'handleReportProcess==>',
    //   action,
    //   inputRow,
    //   inputPreviewShowPrice,
    //   inputDownloadShowPrice,
    // );
    // 根據 action 判斷是 preview 還是 download
    if (action === 'preview' && inputRow !== null) {
      previewReport(inputRow, inputPreviewShowPrice, inputDownloadShowPrice);
    } else if (action === 'preview' && inputRow === null) {
      previewReport(undefined, inputPreviewShowPrice, inputDownloadShowPrice);
    } else if (action === 'download') {
      download(inputPreviewShowPrice, inputDownloadShowPrice);
    } else {
      console.error('Invalid action');
    }
  }
  function handleReport(
    askUser: boolean,
    action: string,
    inputRow: Idetail | null,
    inputPreviewShowPrice: boolean,
    inputDownloadShowPrice: boolean,
  ) {
    // console.log(
    //   'HandleReport==>',
    //   askUser,
    //   action,
    //   inputPreviewShowPrice,
    //   inputDownloadShowPrice,
    // );
    if (askUser) {
      setShowModal(true);
    } else {
      handleReportProcess(
        action,
        inputRow,
        inputPreviewShowPrice,
        inputDownloadShowPrice,
      );
    }
  }

  // 是否列印單價詢問視窗：選擇[顯示]價格
  const handleAskPriceConfirm = async () => {
    // 關閉視窗
    setShowModal(false);

    if (triggerAction !== null) {
      handleReportProcess(triggerAction, selectedRow, true, true);
    }

    setTriggerAction(null); // 重置觸發動作
  };

  // 是否列印單價詢問視窗：選擇[不]顯示價格,或右上角X關閉視窗
  const handleAskPriceCancel = async () => {
    // 關閉視窗
    setShowModal(false);

    if (triggerAction !== null) {
      handleReportProcess(triggerAction, selectedRow, false, false);
    }

    setTriggerAction(null); // 重置觸發動作
  };

  /** Table 資料異動事件 */
  const handleDataChange: TableProps<Idetail>['onDataChange'] = (
    rows,
    rowStart,
    rowEnd,
  ) => {
    setValue(
      'detail',
      detail.map((obj, idx) =>
        idx >= rowStart && idx <= rowEnd ? rows[idx - rowStart] : obj,
      ),
    );
  };

  /** 點選訂單號碼 */
  const checkAskPrice = async (
    row?: Idetail,
    actionType?: 'preview' | 'download',
  ) => {
    // 儲存 row 的資料
    setSelectedRow(row !== undefined ? row : null);

    const responseQueryReportSetting = await axios.doAxios<
      IqueryReportSettingRequest,
      IqueryReportSettingResponse
    >(MethodEnum.post, 'retailerSetup/queryReportRetailerSetup', {
      retailerId: master[EnumMaster.retailerId],
      role: userInfoReducer.role,
      functionId: EnumFunctionId.訂單,
    });

    if (
      responseQueryReportSetting &&
      responseQueryReportSetting.data.data &&
      responseQueryReportSetting.data.status === StatusEnum.完成
    ) {
      const { data } = responseQueryReportSetting.data;

      setTriggerAction(actionType || '');
      // console.log('actionType==>', actionType);
      // console.log('showPriceCode', data.retailerSetup.showPriceCode);
      handleReport(
        data.retailerSetup.showPriceCode.askUser,
        actionType || '',
        row !== undefined ? row : null,
        data.retailerSetup.showPriceCode.previewShowPrice,
        data.retailerSetup.showPriceCode.downloadShowPrice,
      );
    }
  };

  const renderCell: TableProps<Idetail>['renderCell'] = (params) => {
    const { field, row, value } = params;
    /** 日期格式轉換 */
    const converDate = (
      dateStr: string,
      targetDateFormat: DateEnum,
      returnDateFormat: DateEnum,
    ) => {
      return formatDate(returnDateFormat)(
        dateStrParse(targetDateFormat)(inputVal(dateStr)),
      );
    };

    switch (field) {
      /** 點閱紀錄 */
      case EnumDetail.viewed:
        return (
          <Button
            style={{ fontSize: 14 }}
            variant={ButtonVariantEnum.link}
            onClick={(e) => {
              e.stopPropagation();
              getLogRecord(row);
            }}
          >
            {value}
          </Button>
        );
      /** 訂單號碼(打開預覽列印) */
      case EnumDetail.orderNo:
        return row[EnumDetail.upFlag] !== 'D' ? (
          <CopyButton
            text={value}
            onClick={(e) => {
              e.stopPropagation();
              checkAskPrice(row, 'preview');
            }}
          />
        ) : (
          inputVal(value)
        );
      /** 分店/倉庫名稱 */
      case EnumDetail.buyerGLN:
        return (
          <>
            {inputVal(value)}
            {!!value && <br />}
            {inputVal(row[EnumDetail.postBriefName])}
          </>
        );
      /** 訂單日期 */
      case EnumDetail.orderDate:
        return converDate(value, DateEnum.yyyyMMdd, DateEnum['yyyy/MM/dd']);
      case EnumDetail.deliverEndDate:
        // 與deliverDate1 相同，但PM需要一個與欄位相同的名字
        return inputVal(
          converDate(
            row[EnumDetail.deliverEndDate],
            DateEnum.yyyyMMdd,
            DateEnum['yyyy/MM/dd'],
          ),
        );
      case 'deliverDate1':
        // deliverDate1 只有結束日期
        return inputVal(
          converDate(
            row[EnumDetail.deliverEndDate],
            DateEnum.yyyyMMdd,
            DateEnum['yyyy/MM/dd'],
          ),
        );
      case 'deliverDate2':
        return (
          <>
            {inputVal(
              converDate(
                row[EnumDetail.deliverStartDate],
                DateEnum.yyyyMMdd,
                DateEnum['yyyy/MM/dd'],
              ),
            )}
            ~
            {inputVal(
              converDate(
                row[EnumDetail.deliverEndDate],
                DateEnum.yyyyMMdd,
                DateEnum['yyyy/MM/dd'],
              ),
            )}
          </>
        );
      case EnumDetail.updDate: {
        const dateTimeStr = inputVal(
          converDate(
            value,
            DateEnum.yyyyMMddHHmmss,
            DateEnum['yyyy/MM/dd HH:mm:ss'],
          ),
        );
        if ((Number(row.version) || 0) > 0) {
          return (
            <span style={{ color: 'red' }}>
              <span>訂單更新</span>
              <br />
              {dateTimeStr}
            </span>
          );
        }
        return dateTimeStr;
      }
      /** 訂單有效日 */
      case EnumDetail.orderExpireDate:
        return converDate(value, DateEnum.yyyyMMdd, DateEnum['yyyy/MM/dd']);
      /** 送貨起始日 */
      case EnumDetail.deliverStartDate:
        return converDate(value, DateEnum.yyyyMMdd, DateEnum['yyyy/MM/dd']);

      default:
        break;
    }
    return undefined;
  };

  return (
    <>
      <PDFReader
        {...pdfObj}
        onClose={() => {
          handleSubmit(handleSearch(pageObj.pageNo, pageObj.pageSize))();
          setPdfObj((prev: PDFReaderProps) => ({ ...prev, show: false }));
        }}
      />

      <TableTit>
        <span>查詢結果</span>
        <DownloadPdf
          retailerSetup={retailerSetup}
          handleSearch={handleSearch}
          formReturnDetail={formReturnDetail}
          pdfPreview={() => checkAskPrice(undefined, 'preview')}
          userInfoReducer={userInfoReducer}
          pdfDownload={() => checkAskPrice(undefined, 'download')}
        />
      </TableTit>
      <Rim>
        <div
          style={{ overflowY: 'hidden' }}
          className={classCombine('table-responsive', 'has-foot')}
        >
          <Table
            serverRender
            tableClass={classCombine('table', 'tb-multi')}
            hover={false}
            renderCell={renderCell}
            data={detail.map((v, i) => ({ ...v, id: i }))}
            columns={getColumns(retailerSetup[EnumRetailerSetup.queryResults])}
            page={pageObj.pageNo}
            pageSize={pageObj.pageSize}
            totalCount={pageObj.total}
            onPageChange={async (pageNo, pageSize) => {
              await handleSubmit(handleSearch(pageNo, pageSize))();
            }}
            onDataChange={handleDataChange}
          />
        </div>
      </Rim>
      <Modal
        show={askPriceShowModal}
        onHide={handleAskPriceCancel}
        header={<b style={{ color: 'white' }} />}
        footer={
          <>
            <Button type="button" onClick={handleAskPriceConfirm}>
              列印單價
            </Button>
            <Button type="button" onClick={handleAskPriceCancel}>
              不印單價
            </Button>
          </>
        }
      >
        請問報表是否顯示單價?
      </Modal>
    </>
  );
};
export default ResultSecion;
